export const styles = {
  mainContainer:
    "sticky top-0 z-50 flex flex-col w-screen px-6 py-4 bg-white shadow-sm overflow-y-clip shadow-zinc-300 md:hidden",

  //tech dome logo
  logoContainer: "flex items-end space-x-2",
  logoImg: "w-8 h-8",
  logoCaption: "text-blue-500 uppercase ",

  
  navContainer:
    "flex-col items-center justify-center hidden h-full space-y-10 text-2xl uppercase text-zinc-700 ",
};
